import { Location, To } from "react-router-dom-v5-compat";

import { PartialExcept } from "common/types";

import {
  StateParamType,
  Validator
} from "seneca-common/utils/routing/react-router-typesafe-routes/common";

import { ClassAndAssignment } from "features/teachers/pages/assignment/modals/MultipleAssignmentShareModal/hooks/useSortAssignmentsAlphabeticallyByClassName";

export type PartialLocation = PartialExcept<Location, "pathname">;

export const locationType: StateParamType<Location, PartialLocation> = {
  getPlainStateParam(value: PartialLocation) {
    return value;
  },
  getTypedStateParam(value) {
    return value as Location;
  }
};

export const classAndAssignmentArrayType: StateParamType<
  ClassAndAssignment[],
  ClassAndAssignment[]
> = {
  getPlainStateParam(value: ClassAndAssignment[]) {
    return value;
  },
  getTypedStateParam(value) {
    return value as ClassAndAssignment[];
  }
};

export const anyValidator: Validator<any> = (value: unknown): any => {
  return value as any;
};

export const toValidator: Validator<To> = (value: unknown): To => {
  return value as To;
};
